import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import RequestLogsTable from './Table';
import RequestLogView from './View';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: RequestLogsTable, exact: true },
  { path: ':id', component: RequestLogView, exact: true },
];
/* eslint-enable prettier/prettier */

class RequestLog extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN])(RequestLog);
